import { useEffect } from 'react';

interface UseAutoSelectMostRecentLetterParams {
  /** True once the prior-letters list has resolved. Don't auto-select on a stale/empty list. */
  isReady: boolean;
  activeRequestId: string | null;
  /** User explicitly navigated to the upload screen via "Upload new"; suppress auto-select. */
  showUpload: boolean;
  mostRecentRequestId: string | undefined;
  onSelect: (requestId: string) => void;
}

export function useAutoSelectMostRecentLetter({
  isReady,
  activeRequestId,
  showUpload,
  mostRecentRequestId,
  onSelect,
}: UseAutoSelectMostRecentLetterParams) {
  useEffect(() => {
    if (!isReady) return;
    if (activeRequestId) return;
    if (showUpload) return;
    if (!mostRecentRequestId) return;
    onSelect(mostRecentRequestId);
  }, [isReady, activeRequestId, showUpload, mostRecentRequestId, onSelect]);
}
